import { fork } from 'redux-saga/effects';

import { actions } from 'domain/webAppArtwork';
import { itemNavigator } from 'sagas/common';

export default function* navigator(args) {
  yield fork(itemNavigator, { modelName: 'Art', actions, editableFields: [] }, args);
}
